import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../../theme";
import { SocialNetworkLinksProps } from ".";

export type SocialNetworkLinksClassNames =
  | "socialNetworkItem"
  | "socialNetworkList";

export type SocialNetworkLinksClasses = Classes<SocialNetworkLinksClassNames>;
export type SocialNetworkLinksStyles = Styles<SocialNetworkLinksClassNames>;
export type SocialNetworkLinksStylesProps = SocialNetworkLinksProps;

const getStyles: (theme: ThemeItem) => SocialNetworkLinksStyles = (
  theme: ThemeItem
) => ({
  "@media (max-width: 992px)": {
    socialNetworkList: {
      justifyContent: "center",
    },
  },
  socialNetworkList: { display: "flex" },
  socialNetworkItem: {
    background: "#c9cbca",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 35,
    height: 35,
    borderRadius: 4,
    margin: [0, 4],
    transition: ".2s alL",
    "&:hover": {
      background: "rgb(136 136 136 / 42%)",
    },
  },
});

const useSocialNetworkLinksStyles: (
  data?: SocialNetworkLinksStylesProps
) => SocialNetworkLinksClasses = createUseStyles<
  ThemeItem,
  SocialNetworkLinksClassNames
>(getStyles);

export default useSocialNetworkLinksStyles;
